<template>
    <div>
        <img class="bgImg" src="@/assets/default/one.png" alt="" />
        <div class="describe">您的网络已走失！！</div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    methods: {

    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
.bgImg{
    display: block;
    margin: 200px auto 30px;
}
.describe{
    text-align: center;
    font-size: 24px;
    color: #333333;
}
</style>